import React, {Component} from 'react';
import Input from "../fields/Input";

class ProfileFields extends Component {
    constructor(props) {
        super(props);

        this.handleUserInput = this.handleUserInput.bind(this)
    }

    handleUserInput(e) {
        this.props.handleUserInput(e)
    }

    render() {
        return (
            <>
                <Input label={'Email'}
                       placeholder={'Email'}
                       name={'email'}
                       value={this.props.client_data.email}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.email}
                />
                <Input label={'Mobile Number'}
                       placeholder={'Mobile Number'}
                       name={'mobile'}
                       value={this.props.client_data.mobile}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.mobile}
                />
                <Input label={'First Name'}
                       placeholder={'First Name'}
                       name={'first_name'}
                       value={this.props.client_data.first_name}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.first_name}
                />
                <Input label={'Last Name'}
                       placeholder={'Last Name'}
                       name={'last_name'}
                       value={this.props.client_data.last_name}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.last_name}
                />
                <Input label={'Date of Birth'}
                       placeholder={'Date of Birth'}
                       name={'dob'}
                       value={this.props.client_data.dob}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.dob}
                       type={'date'}
                />
                <Input label={'Driver License Number'}
                       placeholder={'Driver License Number'}
                       name={'driver_license'}
                       value={this.props.client_data.driver_license}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.driver_license}
                />
                <Input label={'Driver License Issued'}
                       placeholder={'Driver License Issued'}
                       name={'driver_license_issued'}
                       value={this.props.client_data.driver_license_issued}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.driver_license_issued}
                />
                <Input label={'Driver License Expires'}
                       placeholder={'Driver License Expires'}
                       name={'driver_license_expires'}
                       value={this.props.client_data.driver_license_expires}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.driver_license_expires}
                       type={'date'}
                />
                <Input label={'Address'}
                       placeholder={'Address'}
                       name={'address'}
                       value={this.props.client_data.address}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.address}
                />
                <Input label={'City'}
                       placeholder={'City'}
                       name={'city'}
                       value={this.props.client_data.city}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.city}
                />
                <Input label={'State'}
                       placeholder={'State'}
                       name={'state'}
                       value={this.props.client_data.state}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.state}
                />
                <Input label={'Postcode'}
                       placeholder={'Postcode'}
                       name={'postcode'}
                       value={this.props.client_data.postcode}
                       hanldeChange={this.handleUserInput}
                       error={this.props.errors.postcode}
                />
            </>
        );
    }
}

export default ProfileFields;